<template>
  <div class="text-center my-10">
    <!-- <v-icon large color="vtred">mdi-block-helper</v-icon> -->
    <div class="mb-4 text-h6">ERROR! The requested page is not available.</div>
    <router-link
      v-if="$store.state.sections[0] && $store.state.sections[0][0]"
      class="pointer font-weight-bold text-capitalize text-decoration-underline"
      :to="$store.state.sections[0][0]"
    >
      Go to Home!
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Error",
  components: {},
};
</script>

<style lang="scss" scoped></style>
